import {Directive, HostListener, Input} from '@angular/core';
import {AbstractControl} from '@angular/forms';

@Directive({
	selector: '[amd-no-space-input]'
})
export class NoSpaceInputDirective {
	@Input() element: HTMLInputElement;
	@Input() control?: AbstractControl;

	constructor() {
	}

	@HostListener('input', ['$event'])
	onInput(): void {
		this.element.value = this.element.value.split(' ').join('');
		if (!!this.control) {
			this.control.setValue(this.element.value);
		}
	}

}
